import PreviewTabularData from './PreviewTabularData';

export default PreviewTabularData;
